import React from 'react';
import PropTypes from 'prop-types';

import { DayPickerSingleDateController as ReactDayPickerSingleDateController } from 'react-dates';

import * as Icons from '../icons/Icons';

const propTypes = {
    date: PropTypes.object,
    focused: PropTypes.bool,
    onDateChange: PropTypes.func,
    onFocusChange: PropTypes.func
};

const defaultProps = {
    date: null,
    focused: false,
    onDateChange() {},
    onFocusChange() {}
};

export default class DayPickerSingleDateController extends React.Component {
    constructor(props) {
        super(props);

        this.onDateChange = this.onDateChange.bind(this);
        this.onFocusChange = this.onFocusChange.bind(this);
    }

    onDateChange(date) {
        this.props.onDateChange(date);
    }

    onFocusChange(focus) {
        this.props.onFocusChange(focus);
    }

    render() {
        const arrowIconBack = (<Icons.IconArrowBack className="rec-icon-arrow-back" />);
        const arrowIconForward = (<Icons.IconArrowForward className="rec-icon-arrow-forward" />);

        return (
            <ReactDayPickerSingleDateController
                {...this.props}
                date={this.props.date}
                onDateChange={this.onDateChange}
                focused={this.props.focused}
                onFocusChange={this.onFocusChange}
                navPrev={arrowIconBack}
                navNext={arrowIconForward} />
        );
    }
}

DayPickerSingleDateController.propTypes = propTypes;
DayPickerSingleDateController.defaultProps = defaultProps;
